export const appConstant = {
	// domain: 'https://affiliatesapi.konnektive.com/api/v1',
	//domain: process.env.NODE_ENV === 'production' ? 'https://affiliates.konnektive.com/api/v1' : 'https://devaffiliatesapi.konnektive.com/api/v1',
	// domain: 'https://api.trackfiliates.com/api/v1',
	domain: 'https://devapi.trackfiliates.com/api/v1',
	success: 'SUCCESS',
	failed: 'FAILED',
	edit: 'EDIT',
	add: 'ADD',
	userData: 'userData',
	userNotExist: 'User does not exist.',
	somethingWentWrong: 'Something went wrong',
	currentPasswordDoesNotMatch: 'Current password does not match',
	// domain: 'https://devaffiliates.konnektive.com/api/v1',
};

export const appVariables = {
	EDIT_COMMISSION: 'EDIT_COMMISSION',
	TRANSFER_COMMISSION: 'TRANSFER_COMMISSION',
	ADD_COMMISSION_ITEM: 'ADD_COMMISSION_ITEM',
};

export const apiUrl = {
	// HEALTH CHECK
	HEALTH: '/healthcheck',

	// AUTH
	LOGIN: '/login',
	REQUEST_ACCESS: '/requestaccess',
	LOGUT: '/logoff?authKey=',
	ENCRYPT: '/crypto/encrypt?plainText=',
	DECRYPT: '/crypto/decrypt?encryptedText=',
	// USER
	GET_USER: '/user/profile?authKey=',
	SAVE_USER: '/user/profile/save/',
	UPDATE_USER: '/user/profile/update?authKey=',
	RESET_CURRENT_PASSWORD: '/user/reset/currentpassword/',
	RESET_FORGOT_PASSWORD: '/user/reset/forgotpassword',
	FORGOT_PASSWORD: '/user/email/forgotpassword?email=',
	DEACTIVATE_USER: '/user/account/deactivate?authKey=',
	ACTIVATE_USER: '/user/account/activate?authKey=',
	DELETE_USER: '/user/account/delete?authKey=',

	UPLOAD_COVER_PHOTO: '/user/coverimage/update',
	GET_COVER_PHOTO: '/user/coverimage?authKey=',

	// BANK
	GET_ACTIVE_BANK: '/user/bank/account?authKey=',
	SAVE_BANK: '/user/bank/add?authKey=',
	UPDATE_BANK: '/user/bank/update',
	DELETE_BANK: '/user/bank/delete',
	ACTIVATE_BANK: '/user/bank/activate',

	// REPORT
	GET_PERFORMANCE_REPORT_TABLE: '/report/performanceReport',
	GET_PERFORMANCE_CHAERT: '/report/performanceChart',
	GET_COMMISSION_REPORT_TABLE: '/report/commissionReport',
	GET_COMMISSION_CHAERT: '/report/commissionChart',

	//AFFILIATE
	GET_AFFILIATE: '/Affiliate/getAllAffiliateDetails?authKey=',
	ADD_AFFILIATE: '/Affiliate/createAffiliate?authKey=',
	GET_AFFILIATE_BY_ID: '/Affiliate/getAffiliateUserDetails?sourceId=',
	GET_AFFILIATE_BY_ID_COMMISSION_PROFILE: '/Campaign/getCampaignDetailByAffiliate?sourceId=',
	GET_AFFILIATE_USAGE_TOTAL_VISIT: '/report/affiliateTotalVisitCount?authKey=',
	GET_AFFILIATE_USAGE_AVERAGE_TOTAL_VISIT: '/report/affiliateAvgSessionCount?authKey=',
	GET_AFFILIATE_USAGE_CHART_DATA: '/report/affiliateUsageChart?authKey=',
	GET_AFFILIATE_USAGE_TABLE_DATA: '/report/affiliateUsageReport?authKey=',

	//CAMPAIGNS
	GET_ALL_CAMPAIGNS: '/Campaign/getAllCampaign?authKey=',
	GET_CAMPAIGN_DD: '/Campaign/campaignname/list?companyId=',
	ADD_CAMPAIGN: '/Campaign/add',
	EDIT_CAMPAIGN: '/Campaign/edit',
	GET_DOMAINS: '/Campaign/domain/list?sourceId=',
	DELETE_CAMPAIGN: '/Campaign/delete',

	//COMMISSION_SUMMARY
	GET_COMMISSION_SUMMARY: '/commission/getcommissionSummary?authKey=',
	GET_VIEW_COMMISSION_SUMMARY_BY_ID: '/commission/getCommission?affiliateId=',
	UPDATE_COMMISSION_SUMMARY_BY_ID: '/commission/updateCommission',
	UPDATE_TRANSFER_COMMISSION_BY_ID: '/commission/transferCommission',
	DELETE_COMMISSION_SUMMARY_BY_ID: '/commission/deleteCommission',
};

export const userRoles = {
	CRM: 'CRM Admin',
	AFFILIATE: 'Affiliate',
	MERCHANT: 'Merchant',
	SUPPORT_USER: 'Support User',
};

export const affiliateUsageFilter = [
	{
		label: 'Active',
		value: 'Active',
	},
	{
		label: 'Inactive',
		value: 'Inactive',
	},
	{
		label: 'Pending Confirmation',
		value: 'PendingConfirmation',
	},
	{
		label: 'Deleted',
		value: 'Deleted',
	},
	{
		label: 'LockedOut',
		value: 'LockedOut',
	},
	{
		label: 'Blocked',
		value: 'Blocked',
	},
	{
		label: 'All',
		value: 'All',
	},
];

export const datePickerValues = {
	LAST: 'LAST',
	LASTFOUR: 'LASTFOUR',
	YEST: 'YEST',
	THIS_WEEK: 'THIS_WEEK',
	THIS_MONTH: 'THIS_MONTH',
	CUSTOM: 'CUSTOM',
};

export const dateFormats = {
	MM_DD_YYYY: 'MM/DD/YYYY',
};

export const chartTypes = {
	BAR: 'bar',
	LINE: 'line',
};

export const showInvitationLink = [userRoles.CRM, userRoles.MERCHANT, userRoles.SUPPORT_USER];
export const showAddAffiliate = [userRoles.CRM, userRoles.MERCHANT, userRoles.SUPPORT_USER];
export const showCommissionSummary = [userRoles.CRM];
export const showAffiliateUsageChart = [userRoles.CRM];
export const affiliateReportTable = [userRoles.CRM, userRoles.MERCHANT, userRoles.SUPPORT_USER];
export const trackingDetails = [userRoles.AFFILIATE];
export const commissionProfileAction = [userRoles.CRM, userRoles.MERCHANT, userRoles.SUPPORT_USER];
export const bankCard = [userRoles.AFFILIATE];
export const commissionReportCRMColoums = [userRoles.CRM];
export const performanceReportColoums = [userRoles.CRM, userRoles.MERCHANT, userRoles.SUPPORT_USER];
export const onlyCRM = [userRoles.CRM, userRoles.MERCHANT, userRoles.SUPPORT_USER];
export const onlyMERCHANT = [userRoles.MERCHANT, userRoles.SUPPORT_USER];
export const onlyAFFILIATE = [userRoles.AFFILIATE];

export const colorsList = [
	'#0086fa',
	'#8b40eb',
	'#e67300',
	'#ec8203',
	'#00e6e6',
	'#e60073',
	'#7d48fc',
	'#f69d0b',
	'#e60000',
	'#e8bb00',
	'#00c323',
	'#2979FF',
	'#0073e6',
	'#7300e6',
	'#0000e6',
	'#e6e600',
	'#e600e6',
	'#e60000',
	'#1DE9B6',
	'#00E676',
	'#FFD600',
	'#FF5722',
	'#FF3D00',
	'#546E7A',
	'#651FFF',
	'#3D5AFE',
	'#2196F3',
	'#E91E63',
	'#F44336',
	'#00e67b',
	'#e6006b',
	'#00e608',
	'#00dee6',
	'#006be6',
	'#007efa',
	'#00d7e2',
	'#219dff',
	'#00e63a',
	'#e600ad',
	'#00e6ad',
	'#009ee2',
	'#00b16a',
	'#00de98',
	'#007fc1',
	'#00c3dc',
	'#e60f00',
	'#0064e6',
	'#0fa8ff',
	'#e600d7',
];

export const recaptcha = {
	// siteKey: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI', // for development only
	// siteKey: '6LdwrLgZAAAAAK61iSkzPFXrpDqc5nK7NTJYDUeF', // live site key
	// secretKey: '6LdwrLgZAAAAAL18SaKPhHeOWbXpiwrZ8MXmyiwu', // live secret key
	siteKey: '6LczV9cZAAAAAEiV9sx2laOmu1KsxE_0l28ZiRBg', // live site key
	secretKey: '6LczV9cZAAAAAF97OYbKPjR7yE7BuwPg3jBIS7Yi', // live secret key
};

export const notificationStrings = {
	success: 'success',
	info: 'info',
	warning: 'warning',
	error: 'error',
};
